import { updateItems } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">最新动态</h2>
          <p className="mt-2 text-sm text-foreground-500">51大赛内容更新快讯</p>
        </div>

        <div className="relative pl-8 md:pl-10 border-l-2 border-primary-200">
          {updateItems.map((item, index) => (
            <div key={index} className={`relative pb-8 last:pb-0 ${index === 0 ? '' : ''}`}>
              <div className="absolute -left-[calc(2rem+5px)] md:-left-[calc(2.5rem+5px)] top-0.5 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-50"></div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-1.5 sm:gap-3 mb-1.5">
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                <span className="inline-block px-2 py-0.5 text-xs font-medium rounded-full bg-primary-100 text-primary-700 whitespace-nowrap w-fit">
                  {item.tag}
                </span>
              </div>
              <p className="text-sm md:text-base text-foreground-800 font-medium leading-relaxed">{item.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}